import { goto } from "@/util/navigation"

export default {
    install(Vue) {
        Vue.prototype.$goto = function(to, options) {
            return goto(to, options)
        }
    },
}
